import { hasRecordedFigures, lineRateCell } from '../../../../utils/lineVatRows';
import type { StatementLine } from '../../../../utils/statementBlocks';
import { FigureCell } from './FigureCell';
import { RateCell } from './RateCell';

interface Props {
    line: StatementLine;
    split: boolean;
    currency: string;
}

export function StatementLineFigures({ line, split, currency }: Props) {
    const cell = lineRateCell(line);
    const recorded = hasRecordedFigures(line);
    if (!split) return <FigureCell column="Net" value={recorded ? line.net : null} currency={currency} />;
    return (
        <>
            <RateCell cell={cell} />
            <FigureCell column="Gross" value={line.amount} currency={currency} />
            <FigureCell column="VAT" value={recorded ? line.vat : null} currency={currency} />
            <FigureCell column="Net" value={recorded ? line.net : null} currency={currency} />
        </>
    );
}
